export const name = 'accessibility';


export function setupButtons() {
    let allMetaButtons = document.querySelectorAll( 'a[role="button"]' );
    for ( let i = 0; i < allMetaButtons.length; i++ ) {
        allMetaButtons[i].addEventListener('keydown', metaButtonListener);
    }

    allMetaButtons = document.querySelectorAll( 'a.wp-block-file__button' );
    for ( let i = 0; i < allMetaButtons.length; i++ ) {
        allMetaButtons[i].addEventListener('keydown', metaButtonListener);
        allMetaButtons[i].setAttribute('role', 'button');
    }
}

function metaButtonListener(event) {
    if (event.code !== undefined && event.code === 'Space' ) {
        event.preventDefault();
        event.target.click();
    } else if(event.keyCode === 32) {
        event.preventDefault();
        event.target.click();
    }
}